import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import API from "../../services/api";
import "./auth.css";

const EyeOpen = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M2 8s2.5-5 6-5 6 5 6 5-2.5 5-6 5-6-5-6-5z" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const EyeOff = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M2 8s2.5-5 6-5 6 5 6 5-2.5 5-6 5-6-5-6-5z" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M3 3l10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [showConf, setShowConf] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const [params] = useSearchParams();
  const navigate = useNavigate();

  const token = params.get("token");
  const accountType = (params.get("type") || "admin").toLowerCase();
  const isEmployee = accountType === "employee";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!password || !confirmPassword) {
      setError("All fields are required.");
      return;
    }

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      const resetPath = isEmployee
        ? "/employee-auth/reset-password"
        : "/auth/reset-password";

      await API.post(resetPath, {
        token: token,
        new_password: password,
      });

      setSuccess(true);

      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (err) {
      setError(err?.response?.data?.detail || "Password reset failed.");
    }

    setLoading(false);
  };

  return (
    <div className="auth-root">
      <div className="blob blob-1" />
      <div className="blob blob-2" />
      <div className="blob blob-3" />
      <div className="auth-card auth-reset-card">
        <div className="auth-header">
          <h1 className="auth-title">Reset Password</h1>
          <p className="auth-subtitle">
            {isEmployee
              ? "Set a new password for your employee account"
              : "Enter your new password"}
          </p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        {success ? (
          <div className="modal-success">
            <h2>Password Updated</h2>
            <p>You will be redirected to sign in.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="field-group">
              <label className="field-label" htmlFor="reset-pwd">New Password</label>
              <div className="field-wrapper">
                <input
                  id="reset-pwd"
                  type={showPwd ? "text" : "password"}
                  autoComplete="new-password"
                  className="field-input"
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPwd((v) => !v)}
                  aria-label={showPwd ? "Hide password" : "Show password"}
                >
                  {showPwd ? <EyeOff /> : <EyeOpen />}
                </button>
              </div>
            </div>

            <div className="field-group">
              <label className="field-label" htmlFor="reset-conf">Confirm Password</label>
              <div className="field-wrapper">
                <input
                  id="reset-conf"
                  type={showConf ? "text" : "password"}
                  autoComplete="new-password"
                  className="field-input"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowConf((v) => !v)}
                  aria-label={showConf ? "Hide password" : "Show password"}
                >
                  {showConf ? <EyeOff /> : <EyeOpen />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className={`auth-btn primary-btn ${loading ? "loading" : ""}`}
              disabled={loading}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
